import { GearIcon, TasklistIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HachToanCongNoPage from "../hach-toan-cong-no";
import GanMienGiamPage from "./GanMienGiamPage";
import GanMienGiamNewPage from "./GanMienGiamNewPage";
const MienGiamQuyetToanLayout = () => {
    const { tab } = useParams();
    const navigate = useNavigate();
    const selectedTab = useMemo(() => {
        if (tab === "mien_giam") return "mien_giam";
        if (tab === "quyet_toan") return "quyet_toan";
        return "mien_giam";
    }, [tab]);
    return (
        <Box>
            <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item
                    icon={TasklistIcon}
                    aria-current={selectedTab === "mien_giam" ? "page" : undefined}
                    onClick={() => {
                        navigate(`../../miengiam_v2/mien_giam`);
                    }}
                >
                    Gán miễn giảm
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={GearIcon}
                    aria-current={selectedTab === "quyet_toan" ? "page" : undefined}
                    onClick={() => {
                        navigate(`../../miengiam_v2/quyet_toan`);
                    }}
                >
                    Danh sách quyết toán
                </UnderlineNav.Item>
            </UnderlineNav>
            <Box>{selectedTab === "mien_giam" && <GanMienGiamNewPage />}</Box>
            <Box>{selectedTab === "quyet_toan" && <HachToanCongNoPage />}</Box>

        </Box>
    );
};

export default MienGiamQuyetToanLayout;
